import * as R from 'ramda';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';
import { API_APP_CONFIG } from '../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { ResortToolsConfig } from '../../auth/config/resortToolsConfig';
import { getResource } from '../../language/resources/getResource';


export const KEY_ACTION = ACTION_TYPE.UPDATE_CONFIG_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.UPDATE_CONFIG_REQUEST,
  ACTION_TYPE.UPDATE_CONFIG_RESPONSE,
  ACTION_TYPE.UPDATE_CONFIG_ERROR,
];


/**
 * Creates an action to dispatch that updates the config on the server.
 * @param config the config being saved
 */
export const saveConfigAction = (config: ResortToolsConfig) => makeApiAction(
  {
    method:   'PUT',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: state => API_APP_CONFIG(state.selectedResort.resortId),
    body:     JSON.stringify(config),
    types:    ACTIONS.map(action => ({ type: action, meta: { config } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION)
                                    || !!getLoading(state, ACTION_TYPE.UPDATE_CONFIG_REQUEST, KEY_ACTION),
  },
);


const reducer: ApiReducer<any> = (state, action, error, isLoading, payload) => {
  const config = action.meta.config as ResortToolsConfig;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error || !config) {
    return addError(withBreaker, KEY_ACTION, KEY_ACTION, error || getResource(state.locale, 'SAVE_CONFIG_ACTION_ERROR'));
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, KEY_ACTION, KEY_ACTION);

  return R.assocPath(['resortToolsConfig'], config, noLoadingOrError);
};

export const saveConfigReducer = makeApiReducer<any>(ACTIONS, KEY_ACTION, reducer);
